<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
@if (cloudinaryBackgroundImageUrl || cloudinaryBackgroundImageMobileUrl) {
  <!-- 
    Uses srcset to provide images in different sizes based on screen width, optimizing loading for mobile devices, tablets, desktop and large screens or retina displays
    If the image is smaller than the rendered size, the image will be downloaded in the original size

    Applying the webp format, quality percentage and the width of the image will reduce the image size and improve the performance
    More info: https://www.contentful.com/developers/docs/references/images-api/
  -->
  <picture>
    @if (cloudinaryBackgroundImageUrl) {
      <source
        [srcset]="desktopImageSrcSet"
        [sizes]="'(max-width: 1024px) 1024px, (max-width: 1920px) 1920px, 3840px'"
        [media]="'(min-width: 769px)'"
      />
    }

    @if (cloudinaryBackgroundImageMobileUrl) {
      <source sizes="768px" [srcset]="mobileImageSrcSet" [media]="'(max-width: 768px)'" />
    }

    <!-- We show the alt text of the cloudinary image if it exists as preference, otherwise we show the alt text of the cloudinary mobile image. -->
    <img
      [class]="
        'img-fluid' +
        (cloudinaryBackgroundImageUrl && cloudinaryBackgroundImageMobileUrl
          ? ''
          : cloudinaryBackgroundImageUrl
            ? ' d-none d-md-block'
            : ' d-md-none')
      "
      [style]="customStyles"
      [src]="
        cloudinaryBackgroundImageUrl
          ? cloudinaryBackgroundImageUrl + '?fm=webp&q=75&w=1920'
          : cloudinaryBackgroundImageMobileUrl + '?fm=webp&q=75&w=768'
      "
      [alt]="cloudinaryBackgroundImageUrl ? cloudinaryBackgroundImageAlt : cloudinaryBackgroundImageMobileAlt"
    />
  </picture>
}
